<template>
  <v-app>
    <!-- <RightPanel /> TODO: add after implementing course zoom -->

    <AppBar />

    <v-content>
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </v-content>

    <v-footer app>
      <!-- -->
    </v-footer>
  </v-app>
</template>

<script>
import AppBar from '@/components/course/AppBar.vue';
// import RightPanel from '@/components/course/RightPanel.vue';

export default {
  components: {
    AppBar
    // RightPanel
  }
};
</script>
